<template>
  <div>
    <p class="text-center"><span>※</span>は必須項目です</p>
    <form action="" method="post" @submit.prevent="next()">
      <div class="form">
        <label class="label">氏名<span>※</span></label>
        <div class="inputDiv">
          <input class="input" placeholder="例：山田" name="name1" type="text" required>
          <input class="input" placeholder="例：太郎" name="name3" type="text" required>
        </div>
      </div>
      <div class="form">
        <label class="label">フリガナ<span>※</span></label>
        <div class="inputDiv">
          <input class="input" placeholder="例：ヤマダ" name="name2" type="text" required>
          <input class="input" placeholder="例：タロウ" name="name4" type="text" required>
        </div>
      </div>
      <div class="form">
        <label class="label">電話番号<span class="mr-1">※</span><br class="d-none d-md-block" style="line-height:1;"><small>(ハイフン・スペースは入れないで下さい。)</small></label>
        <input class="input" placeholder="例：09012345678" name="tel" type="tel" required>
      </div>
      <div class="form">
        <label class="label">メールアドレス<span>※</span></label>
        <input class="input" placeholder="例：yamada.t@example.com" name="email" type="email" required>
      </div>
      <div class="form">
        <label class="label label_time">ご連絡のつきやすい時間<span>※</span></label>
        <div class="contact">
          <select class="contact__selectTime" name="contactTime" required id="contactTime">
            <option value="10:00~12:00">10:00~12:00</option>
            <option value="12:00~14:00">12:00~14:00</option>
            <option value="14:00~16:00">14:00~16:00</option>
            <option value="16:00~18:00">16:00~18:00</option>
            <option value="18:00~20:00">18:00~20:00</option>
          </select>
          <p class="contact__text1">ご注文内容について確認のお電話を<br class="d-none d-md-block">させて頂く場合がございます。</p>
        </div>
      </div>
      <div class="form">
        <label class="label">DM希望<span>※</span><br><small>※年に数回のみお送りさせて頂きます</small></label>
        <div class="input input__radio">
          <input type="radio" class="radio" name="dm" value="希望する" id="dm_yes" checked>
          <label for="dm_yes" class="label__dm">希望する</label>
          <input type="radio" class="radio" name="dm" value="希望しない" id="dm_no">
          <label for="dm_no" class="label__dm">希望しない</label>
          <p>DMはメールにて送らせていただきます。</p>
        </div>
      </div>
      <div class="form form_msg">
        <label class="label">備考欄</label>
        <textarea class="input" name="comment" placeholder="" rows="4" cols="10" maxlength="40"></textarea>
      </div>
      <p class="text-center checkBox">
        <input type="checkbox" name="checkBox" value="ok" @click="checkBox" id="checkBox" class="checkBox__input">
        <label for="checkBox" class="checkBox__label"><a href="https://ec.g-spoon.co.jp/?mode=privacy" class="agree" target="_blank">個人情報保護方針</a>、<a href="https://ec.g-spoon.co.jp/?mode=sk" class="agree" target="_blank">特定商取引に基づく表記</a>に同意する</label>
      </p>
      <p><button type="submit" class="btn">確認画面へすすむ<i class="fas fa-chevron-right"></i></button></p>
    </form>
    <p class="a text-center" @click="prev(1)"><span><i class="fas fa-chevron-left mr-1"></i>商品選択へもどる</span></p>
  </div>
</template>

<script>
export default {
  name: 'step4',
  data() {
    return {
    }
  },
  mounted() {
    if (this.reservation.customer.name1 !== '') {
      // 姓名
      let name1 = document.getElementsByName('name1')
      let name3 = document.getElementsByName('name3')
      // フリガナ
      let name2 = document.getElementsByName('name2')
      let name4 = document.getElementsByName('name4')
      // 電話番号
      let tel = document.getElementsByName('tel')
      // メールアドレス
      let email = document.getElementsByName('email')
      // ご連絡のつきやすい時間
      let contactTime = document.getElementsByName('contactTime')
      // DM希望
      let dm = document.getElementsByName('dm')
      // 住所
//      let add1 = document.getElementsByName('add1')
      // let add2 = document.getElementsByName('add2')
      // let add3 = document.getElementsByName('add3')
//      let add4 = document.getElementsByName('add4')
      // 備考欄
      let comment = document.getElementsByName('comment')

      name1[0].value = this.reservation.customer.sei
      name3[0].value = this.reservation.customer.mei

      name2[0].value = this.reservation.customer.kanasei
      name4[0].value = this.reservation.customer.kanamei

      tel[0].value = this.reservation.customer.tel
      email[0].value = this.reservation.customer.email
      contactTime[0].value = this.reservation.customer.contactTime
      if (this.reservation.customer.dm === '希望する') {
        dm[0].checked = true
        dm[1].checked = false
      } else {
        dm[0].checked = false
        dm[1].checked = true
      }
//      add1[0].value = this.reservation.customer.add1
      // add2[0].value = this.reservation.customer.add2
      // add3[0].value = this.reservation.customer.add3
//      add4[0].value = this.reservation.customer.add4
      comment[0].value = this.reservation.customer.comment
    }
  },
  props: [
    'buttonText',
    'step',
    'shops',
    'radioResult',
    'weeks',
    'calData',
    'reservation'
  ],
  methods: {
    next: function () {
      this.$emit('next')
    },
    prev: function(number) {
      this.$emit('prev',number)
    },
    checkBox: function () {
      let checkBox = document.getElementsByName('checkBox')
      if (checkBox[0].checked) {
        this.reservation.flag1 = true
      } else {
        this.reservation.flag1 = false
      }
    },
  }
}


</script>

<style scoped lang="scss">
.agree {
  color: #000;
  border-bottom: 1px solid #000;
  &:hover {
    opacity: 0.7;
    cursor: pointer;
    text-decoration: none;
  }
}
select {
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
}
span {
  color: red;
}
.dm__span {
  color: #000 !important;
  font-size: 8px;
}
.label__dm {
  &:hover {
    cursor: pointer;
  }
}
.a {
  color: #000;
  display: block;
  span {
    border-bottom: 1px solid #000 !important;
    color: #000;
    &:hover {
      opacity: 0.7;
      cursor: pointer;
    }
  }
}
.btn {
  text-align: center;
  display:block;
  margin: 30px auto 0;
  padding:15px 0;
  background-color: #831f17;
  color:#fff;
  width:80%;
  position: relative;
  &:hover {
    opacity:0.7;
    cursor: pointer;
  }
  i {
    color: #fff;
    text-align: right;
    position: absolute;
    right: 30px;
    top: 50%;
    margin-top: -.5em;
  }
}

.form {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 10px;
  height: 50px;
  @media (max-width: 767.98px) {
    display: block;
    margin-bottom: 15px;
  }
  &_msg {
    align-content: flex-start;
    align-items: flex-start;
  }
  .label {
    width:40%;
    text-align: left;
    padding-left: 60px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.92;
    color: #333333;
    margin-bottom: 0px;
    @media (max-width: 767.98px) {
      padding: 0;
      width: 100%;
    }
    &_time {
      margin-right: -15px;
    }
    &--address {
      margin-bottom: 0;
      margin-right: 5px;
    }
  }
  .inputDiv {
    width: 60%;
    margin-right: 50px;
    display: flex;
    input {
      text-align: left;
      border-radius: 3px;
      border: solid 1px #cccccc;
      width: 49%;
      margin-right: 5px;
    }
    @media (max-width: 767.98px) {
      width: 100%;
    }
  }
  .input {
    width: 60%;
    margin-right: 50px;
    text-align: left;
    border-radius: 3px;
    border: solid 1px #cccccc;
    @media (max-width: 767.98px) {
      width: 100%;
    }
    &__radio {
      text-align: left;
      border: 0;
      display: flex;
      align-items: center;
      label {
        padding-top: 3px;
        padding-left: 3px;
        margin-bottom: 0;
      }
      p {
        margin-bottom: 0;
        padding-top: 3px;
        padding-left: 8px;
        font-size: 11px;
        @media (max-width: 575.98px) {
          width: 40%;
        }
        @media (min-width: 768px) and (max-width: 1199.98px) {
          width: 40%;
        }
      }
    }
    &--address {
      display: flex;
      align-items: center;
      border: 0;
      &__input {
        width: 33%;
        border-radius: 3px;
        border: solid 1px #cccccc;
        height: 35px;
        margin-right: 5px;
        padding-left: 5px;
        @media (max-width: 767.98px) {
          width: 50%;
          // font-size: 12px;
          margin-left: 7px;
        }
      }
    }
  }
  .inputAddress {
    height: 35px;
    margin-top: 15px;
  }
  &--kome {
    text-align: left;
    margin: 0;
  }
  textarea {
    border-radius: 3px;
    border: solid 1px #cccccc;
  }
  .contact {
    display: flex;
    align-items: center;
    &__selectTime {
      width: 130px;
      height: 35px;
      border-radius: 3px;
      border: solid 1px #cccccc;
    }
    &__text1 {
      font-family: YuMin_36pKn;
      font-size: 11px;
      font-weight: 500;
      line-height: 1.36;
      text-align: left;
      color: #333333;
      margin-bottom: 0;
      margin-left: 10px;
    }
  }
}
.checkBox {
  margin-top: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 767.98px) {
    margin-top: 130px;
  }
  &__input {
    width: 20px;
    height: 20px;
    border-radius: 5px;
    border: solid 1px #cccccc;
    margin-top: 4px;
    margin-right: 5px;
    @media (max-width: 767.98px) {
      margin-top: 0;
    }
    &:hover {
      cursor: pointer;
    }
  }
  &__label {
    font-size: 12px;
    font-weight: 500;
    line-height: 2.33;
    text-align: center;
    color: #333333;
    margin-bottom: 0;
    span {
      border-bottom: 1px solid #ccc;
      color: #000;
    }
  }
}
</style>
